module.exports = __webpack_public_path__ + "img/img4.05a7db11.svg";